import { useState, useEffect } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import moment from 'moment'
import _ from 'lodash'

import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import LowPriorityIcon from '@mui/icons-material/LowPriority'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import CachedIcon from '@mui/icons-material/Cached'
import AllInclusiveIcon from '@mui/icons-material/AllInclusive'
import SwapVertIcon from '@mui/icons-material/SwapVert'
import { Card } from '@mui/material'

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

import { constants as cons } from '../../Constants/constants'
import { getOne, newPut } from '../../helper/baseFetch_v2'
import { post } from '../../helper/baseFetch'
import { setQueueConfig, setQueueConfigValue, setQueueConfigResourcesStepsValue } from '../../actions/queueConfigAction'
import { EditCreateDisplay } from '../../Component/EditCreateDisplay/EditCreateDisplay'
import { TempTextInput } from '../../Component/Input/TempTextInput'
import { TempBtn } from '../../Component/Input/TempBtn'
import { TempAutoSelectInput } from '../../Component/Input/TempAutoSelectInput'
import { getString, helperTextStyles } from '../../helper/util'
import { GlobalDialog } from '../../Component/GlobalDialog'
import { ResourcesSteps } from './ResourcesSteps'
import { ResetDialog } from './ResetDialog'
import { CounterProfileSelectField } from './CounterProfileSelectField'
import useRestaurant from '../../hooks/Restaurant/useRestaurant'
import { BOOLEAN_OPTIONS } from '../../Constants/type'
import { Clear } from '@mui/icons-material'
import { getContent } from '../../Component/EditCreateDisplay/EditUtil'

export const QueueConfigEdit = () => {
  const dispatch = useDispatch()
  const store = useStore()
  const history = useHistory()
  const params = useParams()
  const [ready, setReady] = useState(false)
  const [clear, setClear] = useState(true)
  const [dialog, setDialog] = useState({
    open: false,
    dialogActions: [],
  })

  const defaultError = { transferable: '', checkOutType: '', maxTicketPerSection: '', limitTicketInMinute: '' }
  const [error, setError] = useState(defaultError)
  const helperTextStylesClasses = helperTextStyles()
  const [resetDialogOpen, setResetDialogOpen] = useState(false)
  const resource = 'QueueConfig'
  const savedQueueConfig = useSelector((state) => state.queueConfig.ui.queueConfig)
  const lang = useSelector((state) => state.lang.ui.lang)
  const theme = useSelector((state) => state.theme.ui.theme)
  const { getRestaurantIdAndName } = useRestaurant(params.id)

  const fields = [
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'queueType' },
      value: savedQueueConfig.queueType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_TEMPLATE.QUEUE_TYPE,
      disableClearable: true,
      name: 'queueType',
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'rollTagType' },
      value: savedQueueConfig.rollTagType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_TEMPLATE.ROLL_TAG_TYPE,
      disableClearable: true,
      name: 'rollTagType',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'rollTagShiftValue' },
      value: savedQueueConfig.rollTagShiftValue,
      name: 'rollTagShiftValue',
      type: cons.TYPE.NUMBER,
      isEndOfLine: true,
    },
    {
      type: cons.TYPE.TITLE,
      value: { resource: resource, key: 'display' },
      className: 'sub-title',
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'showTableNo' },
      value: savedQueueConfig.showTableNo,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.SHOW_TABLE_NO,
      name: 'showTableNo',
      disableClearable: true,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'showTableType' },
      value: savedQueueConfig.showTableType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.SHOW_TABLE_TYPE,
      name: 'showTableType',
      disableClearable: true,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'tagSequenceDisplay' },
      value: savedQueueConfig.tagSequenceDisplay,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.TAG_SEQUENCE_DISPLAY,
      name: 'tagSequenceDisplay',
      disableClearable: true,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'displayType' },
      value: savedQueueConfig.displayType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_TEMPLATE.DISPLAY_TYPE,
      disableClearable: true,
      name: 'displayType',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'counterTagType' },
      value: savedQueueConfig.counterTagType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.COUNTER_TAG_TYPE,
      name: 'counterTagType',
      disableClearable: true,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'quotaDisplay' },
      value: savedQueueConfig.quotaDisplay,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.QUOTA_DISPLAY,
      name: 'quotaDisplay',
      disableClearable: true,
      isEndOfLine: true,
    },
    {
      type: cons.TYPE.TITLE,
      value: { resource: resource, key: 'quota' },
      className: 'sub-title',
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'quotaType' },
      value: savedQueueConfig.quotaType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.QUOTA_TYPE,
      disableClearable: true,
      name: 'quotaType',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'timeSectionQuota' },
      value: savedQueueConfig.timeSectionQuota,
      name: 'timeSectionQuota',
      type: cons.TYPE.NUMBER,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'personalLimitType' },
      value: savedQueueConfig.personalLimitType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.PERSONAL_LIMIT_TYPE,
      disableClearable: true,
      name: 'personalLimitType',
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'releaseQuotaOnDelete' },
      value: savedQueueConfig.releaseQuotaOnDelete,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.RELEASE_QUOTA_ON_DELETE,
      disableClearable: true,
      name: 'releaseQuotaOnDelete',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'maxTicketPerSection' },
      value: savedQueueConfig.maxTicketPerSection,
      type: cons.TYPE.NUMBER,
      disableClearable: true,
      onClickEndAdornmentIconButton: () => {
        setNull('maxTicketPerSection')
      },
      endAdornmentIconButton: <Clear fontSize={cons.SIZE.SMALL} />,
      name: 'maxTicketPerSection',
      isEndOfLine: false,
      helperText: error.maxTicketPerSection,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'limitTicketInMinute' },
      value: savedQueueConfig.limitTicketInMinute,
      type: cons.TYPE.NUMBER,
      disableClearable: true,
      onClickEndAdornmentIconButton: () => {
        setNull('limitTicketInMinute')
      },
      endAdornmentIconButton: <Clear fontSize={cons.SIZE.SMALL} />,
      name: 'limitTicketInMinute',
      isEndOfLine: true,
      helperText: error.limitTicketInMinute,
    },
    {
      type: cons.TYPE.TITLE,
      value: { resource: resource, key: 'checkInCheckOut' },
      className: 'sub-title',
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'checkInType' },
      value: savedQueueConfig.checkInType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.QUEUE_CHECK_IN_TYPE,
      disableClearable: true,
      name: 'checkInType',
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'ticketExpiredMinute' },
      value: savedQueueConfig.ticketExpiredMinute,
      name: 'ticketExpiredMinute',
      type: cons.TYPE.NUMBER,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'checkInBeforeMinute' },
      value: savedQueueConfig.checkInBeforeMinute === null ? '' : savedQueueConfig.checkInBeforeMinute,
      type: cons.TYPE.NUMBER,
      disableClearable: true,
      onClickEndAdornmentIconButton: () => {
        setUnlimitedQuota('checkInBeforeMinute')
      },
      endAdornmentIconButton: <AllInclusiveIcon fontSize={cons.SIZE.SMALL} />,
      name: 'checkInBeforeMinute',
      placeholder: savedQueueConfig.checkInBeforeMinute === null ? 'Unlimited' : '',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'checkInLateMinute' },
      value: savedQueueConfig.checkInLateMinute === null ? '' : savedQueueConfig.checkInLateMinute,
      type: cons.TYPE.NUMBER,
      disableClearable: true,
      onClickEndAdornmentIconButton: () => {
        setUnlimitedQuota('checkInLateMinute')
      },
      endAdornmentIconButton: <AllInclusiveIcon fontSize={cons.SIZE.SMALL} />,
      name: 'checkInLateMinute',
      placeholder: savedQueueConfig.checkInLateMinute === null ? 'Unlimited' : '',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'inputCheckInSize' },
      value: savedQueueConfig.inputCheckInSize,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.INPUT_CHECK_IN_SIZE,
      name: 'inputCheckInSize',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'minCheckInSize' },
      value: savedQueueConfig.minCheckInSize,
      name: 'minCheckInSize',
      type: cons.TYPE.NUMBER,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'maxCheckInSize' },
      value: savedQueueConfig.maxCheckInSize,
      name: 'maxCheckInSize',
      type: cons.TYPE.NUMBER,
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'checkOutType' },
      value: savedQueueConfig.checkOutType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.QUEUE_CHECK_OUT_TYPE,
      disableClearable: true,
      name: 'checkOutType',
      isEndOfLine: false,
      helperTextIcon: true,
      helperText: error.checkOutType,
      FormHelperTextProps: { className: helperTextStylesClasses.root },
    },
    {
      type: cons.TYPE.TITLE,
      value: { resource: resource, key: 'delay' },
      className: 'sub-title',
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'delayEnable' },
      value: savedQueueConfig.delayEnable,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.DELAY_ENABLE,
      disableClearable: true,
      name: 'delayEnable',
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'delayMaxMinute' },
      value: savedQueueConfig.delayMaxMinute,
      name: 'delayMaxMinute',
      type: cons.TYPE.NUMBER,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'delayReminderAnswerSecond' },
      value: savedQueueConfig.delayReminderAnswerSecond,
      name: 'delayReminderAnswerSecond',
      type: cons.TYPE.NUMBER,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'delayReminderTriggerSecond' },
      value: savedQueueConfig.delayReminderTriggerSecond,
      name: 'delayReminderTriggerSecond',
      type: cons.TYPE.NUMBER,
      isEndOfLine: false,
    },
    {
      type: cons.TYPE.TITLE,
      value: { resource: resource, key: 'transfer' },
      className: 'sub-title',
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'transferable' },
      value: savedQueueConfig.transferable,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.TRANSFERABLE,
      disableClearable: true,
      name: 'transferable',
      isEndOfLine: false,
      helperTextIcon: true,
      helperText: error.transferable,
      FormHelperTextProps: { className: helperTextStylesClasses.root },
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'useTransferableTicketLabel' },
      value: savedQueueConfig.useTransferableTicketLabel,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.USE_TRANSFERABLE_LABEL,
      disableClearable: true,
      name: 'useTransferableTicketLabel',
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'transferableType' },
      value: savedQueueConfig.transferableType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.TRANSFERABLE_TYPE,
      disableClearable: true,
      name: 'transferableType',
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'transferConcurrentCount' },
      value: savedQueueConfig.transferConcurrentCount,
      type: cons.TYPE.NUMBER,
      name: 'transferConcurrentCount',
    },
    {
      type: cons.TYPE.TITLE,
      value: { resource: resource, key: 'vip' },
      className: 'sub-title',
    },
    {
      className: 'edit-create-input',
      value: savedQueueConfig.vipType,
      label: { resource: resource, key: 'vipType' },
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.VIP_TYPE,
      name: 'vipType',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      value: savedQueueConfig.vipResetType,
      label: { resource: resource, key: 'vipResetType' },
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.VIP_RESET_TYPE,
      name: 'vipResetType',
      disableClearable: true,
      isEndOfLine: false,
    },
    {
      type: cons.TYPE.TITLE,
      value: { resource: resource, key: 'others' },
      className: 'sub-title',
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'queuePeriod' },
      value: savedQueueConfig.queuePeriod,
      name: 'queuePeriod',
      type: cons.TYPE.NUMBER,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'repeatQueue' },
      value: savedQueueConfig.repeatQueue,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.REPEAT_QUEUE,
      name: 'repeatQueue',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'quickQueueGroupName' },
      value: savedQueueConfig.quickQueueGroupName,
      name: 'quickQueueGroupName',
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'checksumExpiryLimit' },
      value: savedQueueConfig.checksumExpiryLimit,
      name: 'checksumExpiryLimit',
      type: cons.TYPE.NUMBER,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'genFromTemplate' },
      value: savedQueueConfig.genFromTemplate,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.GEN_FROM_TEMPLATE,
      name: 'genFromTemplate',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'redisSequence' },
      value: savedQueueConfig.redisSequence,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.REDIS_SEQUENCE,
      disableClearable: true,
      name: 'redisSequence',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'deliveryType' },
      value: savedQueueConfig.deliveryType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.DELIVERY_TYPE,
      disableClearable: true,
      name: 'deliveryType',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'requiredOtp' },
      value: savedQueueConfig.requiredOtp,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.REQUIRED_OTP,
      disableClearable: true,
      name: 'requiredOtp',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      value: savedQueueConfig.autoTimeType,
      label: { resource: resource, key: 'autoTimeType' },
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.AUTO_TIME_TYPE,
      name: 'autoTimeType',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'prioritize' },
      value: savedQueueConfig.prioritize,
      type: cons.TYPE.SELECT,
      selectValue: BOOLEAN_OPTIONS,
      disableClearable: true,
      name: 'prioritize',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'limitDistance' },
      value: savedQueueConfig.limitDistance,
      name: 'limitDistance',
      type: cons.TYPE.NUMBER,
      clear: true,
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'requiredPass' },
      value: savedQueueConfig.requiredPass,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.REQUIRED_PASS,
      disableClearable: true,
      name: 'requiredPass',
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      type: cons.TYPE.FUNCTION,
      value: (
        <CounterProfileSelectField
          resource={resource}
          resourceKey={'counterProfileCode'}
          value={savedQueueConfig.counterProfileCode}
          onChangeInput={onChangeInput}
          restUrlId={params.id}
        />
      ),
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'timeSlotDisplayBeforeMinute' },
      value: savedQueueConfig.timeSlotDisplayBeforeMinute,
      type: cons.TYPE.NUMBER,
      disableClearable: true,
      name: 'timeSlotDisplayBeforeMinute',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'timeSlotDisplayAfterMinute' },
      value: savedQueueConfig.timeSlotDisplayAfterMinute,
      type: cons.TYPE.NUMBER,
      disableClearable: true,
      name: 'timeSlotDisplayAfterMinute',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'noShowType' },
      value: savedQueueConfig.noShowType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.NO_SHOW_TYPE,
      disableClearable: true,
      name: 'noShowType',
      isEndOfLine: false,
    },
    {
      type: cons.TYPE.TITLE,
      value: { resource: resource, key: 'queueSteps' },
    },
    {
      className: 'edit-create-input',
      type: cons.TYPE.FUNCTION,
      value: (
        <>
          <div>
            <TempBtn
              btnSetting={{
                onClick: addQueueSteps,
                variant: cons.STYLE.VARIANT.CONTAINED,
                color: cons.STYLE.PRIMARY,
                label: { resource: resource, key: 'addQueueSteps' },
                icon: <AddIcon />,
              }}
            ></TempBtn>
          </div>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="templateValue">
              {(provided) => {
                return (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {savedQueueConfig.queueSteps &&
                      savedQueueConfig.queueSteps.length > 0 &&
                      savedQueueConfig.queueSteps.map((item, queueStepsIndex) => {
                        return (
                          <Draggable key={item + queueStepsIndex} draggableId={item + queueStepsIndex} index={queueStepsIndex}>
                            {(provided) => {
                              return (
                                <Card
                                  className="card brand-id-wrapper"
                                  key={queueStepsIndex}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <div className="content-icon">
                                    <SwapVertIcon color={cons.STYLE.PRIMARY} fontSize={cons.SIZE.LARGE} />
                                  </div>
                                  <TempAutoSelectInput
                                    inputSetting={{
                                      className: 'edit-create-input',
                                      label: { resource: resource, key: 'queueSteps' },
                                      value: item,
                                      type: cons.TYPE.SELECT,
                                      selectValue: cons.CHOICES.QUEUE_CONFIG.QUEUE_STEPS,
                                      name: 'queueSteps',
                                      disableClearable: true,
                                      isEndOfLine: true,
                                      displayAnyway: true,
                                    }}
                                    handleChange={onChangeInput}
                                    index={queueStepsIndex}
                                  />
                                  <TempBtn
                                    btnSetting={{
                                      className: 'edit-create-btn',
                                      onClick: () => removeQueueSteps(queueStepsIndex),
                                      variant: cons.STYLE.VARIANT.CONTAINED,
                                      color: cons.STYLE.PRIMARY,
                                      label: { key: 'deleteBtn' },
                                      icon: <DeleteIcon />,
                                    }}
                                  ></TempBtn>
                                </Card>
                              )
                            }}
                          </Draggable>
                        )
                      })}
                    {provided.placeholder}
                  </div>
                )
              }}
            </Droppable>
          </DragDropContext>
        </>
      ),
      isEndOfLine: true,
    },
    {
      type: cons.TYPE.TITLE,
      value: { resource: resource, key: 'campaign' },
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'campaignQueue' },
      value: savedQueueConfig.campaignQueue,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.CAMPAIGN_QUEUE,
      name: 'campaignQueue',
      isEndOfLine: false,
    },
    {
      className: `edit-create-input`,
      label: { resource: resource, key: 'campaignType' },
      value: savedQueueConfig.campaignType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.CAMPAIGN_TYPE,
      disableClearable: true,
      name: 'campaignType',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'eventCheckInType' },
      value: savedQueueConfig.eventCheckInType,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.QUEUE_CHECK_IN_TYPE,
      disableClearable: true,
      name: 'eventCheckInType',
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'campaignStartTimestamp' },
      value: savedQueueConfig.campaignStartTimestamp,
      name: 'campaignStartTimestamp',
      type: cons.TYPE.DATETIME_LOCAL,
      step: 1,
      clear: true,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'campaignEndTimestamp' },
      value: savedQueueConfig.campaignEndTimestamp,
      name: 'campaignEndTimestamp',
      type: cons.TYPE.DATETIME_LOCAL,
      step: 1,
      clear: true,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'preparationDay' },
      value: savedQueueConfig.preparationDay,
      name: 'preparationDay',
      type: cons.TYPE.NUMBER,
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'email' },
      value: !savedQueueConfig.email ? false : savedQueueConfig.email,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.EMAIL,
      name: 'email',
      disableClearable: true,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'mobile' },
      value: !savedQueueConfig.mobile ? false : savedQueueConfig.mobile,
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.MOBILE,
      name: 'mobile',
      disableClearable: true,
      isEndOfLine: true,
    },
    {
      type: cons.TYPE.TITLE,
      value: { resource: resource, key: 'attendance' },
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'attendanceEnable' },
      value: savedQueueConfig.attendanceEnable,
      name: 'attendanceEnable',
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.ATTENDANCE_ENABLE,
      disableClearable: true,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'attendanceMethodList' },
      value: savedQueueConfig.attendanceMethodList,
      name: 'attendanceMethodList',
      type: cons.TYPE.SELECT,
      selectValue: cons.CHOICES.QUEUE_CONFIG.ATTENDANCE_METHODS_LIST,
      multiple: true,
      disableClearable: true,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'attendanceLateTicketInterval' },
      value: savedQueueConfig.attendanceLateTicketInterval,
      tooltip: { resource: resource, key: 'attendanceLateTicketIntervalTooltip' },
      name: 'attendanceLateTicketInterval',
      type: cons.TYPE.NUMBER,
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'attendanceExpiredMinute' },
      value: savedQueueConfig.attendanceExpiredMinute,
      name: 'attendanceExpiredMinute',
      type: cons.TYPE.NUMBER,
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      label: { resource: resource, key: 'attendanceDistance' },
      value: savedQueueConfig.attendanceDistance,
      name: 'attendanceDistance',
      type: cons.TYPE.NUMBER,
      isEndOfLine: true,
    },
    {
      className: 'sub-sub-title',
      type: cons.TYPE.TITLE,
      value: { resource: resource, key: 'resourcesSteps' },
    },
    {
      className: 'edit-create-input',
      type: cons.TYPE.FUNCTION,
      value: <ResourcesSteps onChangeInput={onChangeInput} resource={resource} />,
      isEndOfLine: true,
    },
  ]
  const content = [
    {
      tab: fields.map((inputSetting, index) => {
        let content = getContent(inputSetting, index, onChangeInput)
        return (
          <div className="edit-display-wrapper" key={index}>
            {content}
            {inputSetting.isEndOfLine && <div></div>}
          </div>
        )
      }),
      btn: true,
    },
  ]

  const bottomBtns = [
    {
      variant: cons.STYLE.VARIANT.CONTAINED,
      color: cons.STYLE.PRIMARY,
      label: { key: 'save' },
      onClick: onClickSave,
      className: 'margin-left-16',
      icon: <SaveIcon />,
    },
    {
      variant: cons.STYLE.VARIANT.CONTAINED,
      color: cons.STYLE.PRIMARY,
      label: { key: 'clear' },
      disabled: false,
      onClick: () => setClear(true),
      className: 'margin-left-16',
      icon: <ClearIcon />,
    },
  ]

  // const handleClose = () => {
  //   setDialog({
  //     open: false,
  //     dialogActions: []
  //   })
  // };

  const onClickBackToEdit = () => {
    setDialog({
      open: false,
      dialogActions: [],
    })
    setClear(true)
  }

  const onClickBackToList = () => {
    setDialog({
      open: false,
      dialogActions: [],
    })
    history.push('/' + cons.PATH.SHOP.SYSTEM_GROUP_RESTAURANT)
  }

  const setUnlimitedQuota = (name) => {
    onChangeInput(name, null)
  }

  const setNull = (name) => {
    dispatch(setQueueConfigValue(name, savedQueueConfig, '', null))
  }

  function onDragEnd(result) {
    if (!result.destination) return
    let newQueueSteps = _.cloneDeep(savedQueueConfig.queueSteps)
    const [reorderedItem] = newQueueSteps.splice(result.source.index, 1)
    newQueueSteps.splice(result.destination.index, 0, reorderedItem)
    dispatch(setQueueConfigValue('queueSteps', savedQueueConfig, '', newQueueSteps))
  }

  function addQueueSteps() {
    let newQueueSteps = _.cloneDeep(savedQueueConfig.queueSteps)
    newQueueSteps && newQueueSteps.length > 0 ? newQueueSteps.push('') : (newQueueSteps = [''])
    dispatch(setQueueConfigValue('queueSteps', savedQueueConfig, '', newQueueSteps))
  }

  function removeQueueSteps(idx) {
    let newQueueSteps = _.cloneDeep(savedQueueConfig.queueSteps)
    if (newQueueSteps && newQueueSteps.length > 0) {
      newQueueSteps = newQueueSteps.filter((item, newQueueStepsIndex) => newQueueStepsIndex !== idx)
    }
    dispatch(setQueueConfigValue('queueSteps', savedQueueConfig, '', newQueueSteps))
  }

  function validate(savedQueueConfig) {
    let newError = { ...error }

    // console.log('Number.isInteger(savedQueueConfig.limitTicketInMinute)', Number.isInteger(savedQueueConfig.limitTicketInMinute))
    // console.log('Number.isInteger(savedQueueConfig.maxTicketPerSection)', Number.isInteger(savedQueueConfig.maxTicketPerSection))
    // console.log('savedQueueConfig.limitTicketInMinute !== null', savedQueueConfig.limitTicketInMinute !== null)
    // console.log('savedQueueConfig.maxTicketPerSection !== null', savedQueueConfig.maxTicketPerSection !== null)

    if (
      (Number.isInteger(savedQueueConfig.limitTicketInMinute) && Number.isInteger(savedQueueConfig.maxTicketPerSection)) ||
      (savedQueueConfig.limitTicketInMinute === null && savedQueueConfig.maxTicketPerSection === null)
    ) {
      newError.maxTicketPerSection = ''
      newError.limitTicketInMinute = ''
    } else {
      newError.maxTicketPerSection = 'Both Max Ticket Per Section and Limit Ticket In Minute should be integer or empty.'
      newError.limitTicketInMinute = 'Both Max Ticket Per Section and Limit Ticket In Minute should be integer or empty.'
    }

    if (savedQueueConfig.transferable && savedQueueConfig.checkOutType === 'NONE') {
      newError.transferable = 'Check Out Type Should Not be NONE if transferrable is true'
      newError.checkOutType = 'Check Out Type Should Not be NONE if transferrable is true'
    } else {
      newError.transferable = ''
      newError.checkOutType = ''
    }

    setError(newError)
  }

  function onChangeInput(name, e, idx) {
    if (e === '') {
      e = null
    }

    switch (name) {
      case 'campaignStartTimestamp':
      case 'campaignEndTimestamp':
        dispatch(setQueueConfigValue(name, savedQueueConfig, '', e ? Number(moment(e).format('x')) : null))
        break
      case 'timeSectionQuota':
      case 'rollTagShiftValue':
      case 'ticketExpiredMinute':
      case 'checksumExpiryLimit':
      case 'queuePeriod':
      case 'minCheckInSize':
      case 'maxCheckInSize':
      case 'checkInLateMinute':
      case 'checkInBeforeMinute':
      case 'attendanceLateTicketInterval':
      case 'attendanceExpiredMinute':
      case 'attendanceDistance':
        //TO-DO
        //a quick fix,
        // when user input invalid number, the input will fixed as 0
        // user input 0.1 > fixed to 0
        // second time user input 0.2 > the non-change 0 does not trigger useState change
        // causing the input field displaying 0.2
        dispatch(setQueueConfigValue(name, savedQueueConfig, '', e))
        dispatch(setQueueConfigValue(name, savedQueueConfig, '', e === '-' || !e ? e : Number.isInteger(Number(e)) ? parseInt(e) : 0))
        break
      case 'queueSteps':
        let newQueueSteps = _.cloneDeep(savedQueueConfig.queueSteps)
        newQueueSteps = newQueueSteps.map((newQueueStepsValue, newQueueStepsIndex) => {
          if (newQueueStepsIndex === idx) {
            newQueueStepsValue = e
          }
          return newQueueStepsValue
        })
        dispatch(setQueueConfigValue(name, savedQueueConfig, '', newQueueSteps))
        break
      case 'dailyResetTime':
        if (!e) {
          dispatch(setQueueConfigValue(name, savedQueueConfig, '', e))
          return
        }

        let time = e
        const timeRegex = /^[0-9]{2}:[0-9]{2}$/
        if (time.match(timeRegex)) {
          time = time + ':00'
        }
        dispatch(setQueueConfigValue(name, savedQueueConfig, '', time))
        break
      case 'resourcesSteps':
        dispatch(setQueueConfigResourcesStepsValue(name, savedQueueConfig, '', e, idx))
        break
      case 'transferable':
      case 'checkOutType':
        dispatch(setQueueConfigValue(name, savedQueueConfig, '', e))
        break
      case 'maxTicketPerSection':
      case 'limitTicketInMinute':
        dispatch(setQueueConfigValue(name, savedQueueConfig, '', Number(e)))
        break
      default:
        dispatch(setQueueConfigValue(name, savedQueueConfig, '', e))
        break
    }
  }

  function onClickClearDialog() {
    setResetDialogOpen(true)
  }

  function onClickReset() {
    newPut({
      path: cons.PATH.SHOP.QUEUE.RESET_CURRENT_TIME_SECTION + '/' + params.id,
      body: undefined,
      successCallback: () => {
        setDialog({
          open: true,
          onClose: onClickBackToEdit,
          dialogContentText: { key: 'resetSuccess' },
          dialogActions: [
            { label: { key: 'backEdit' }, onClick: onClickBackToEdit, icon: <ArrowBackIcon /> },
            { label: { key: 'backList' }, onClick: onClickBackToList, icon: <LowPriorityIcon /> },
          ],
        })
        setClear(false)
      },
      store: store
    })
  }

  function onClickSave() {
    let newSavedQueueConfig = _.cloneDeep(savedQueueConfig)

    if (Object.values(error).some((value) => value)) {
      return
    }

    setError(defaultError)

    let newCustomData = []

    if (newSavedQueueConfig.email) {
      newCustomData.push({ type: 'EMAIL', required: true })
    }
    if (newSavedQueueConfig.mobile) {
      newCustomData.push({ type: 'MOBILE', required: true })
    }

    delete newSavedQueueConfig.resetUpdateTimestamp

    newSavedQueueConfig.customData = newCustomData.length === 0 ? null : JSON.stringify(newCustomData)
    newSavedQueueConfig.queueSteps =
      newSavedQueueConfig.queueSteps && newSavedQueueConfig.queueSteps.length > 0
        ? JSON.stringify(newSavedQueueConfig.queueSteps.filter((item) => item))
        : null
    newSavedQueueConfig.resourcesSteps =
      newSavedQueueConfig.resourcesSteps && newSavedQueueConfig.resourcesSteps.length > 0
        ? JSON.stringify(newSavedQueueConfig.resourcesSteps.filter((item) => item))
        : null

    if (savedQueueConfig.id) {
      newPut({
        path: cons.PATH.SHOP.QUEUE.QUEUE_CONFIG + '/' + params.id,
        body: newSavedQueueConfig,
        successCallback: () => {
          setDialog({
            open: true,
            onClose: onClickBackToEdit,
            dialogContentText: { key: 'editSuccess' },
            dialogActions: [
              { label: { key: 'backEdit' }, onClick: onClickBackToEdit, icon: <ArrowBackIcon /> },
              { label: { key: 'backList' }, onClick: onClickBackToList, icon: <LowPriorityIcon /> },
            ],
          })
          setClear(false)
        },
        store: store
      })
      // console.log(tempSavedQueueConfig)
    } else {
      newSavedQueueConfig.restUrlId = params.id
      post(
        cons.PATH.SHOP.QUEUE.QUEUE_CONFIG,
        newSavedQueueConfig,
        () => {
          setDialog({
            open: true,
            onClose: onClickBackToEdit,
            dialogContentText: { key: 'editSuccess' },
            dialogActions: [
              { label: { key: 'backEdit' }, onClick: onClickBackToEdit, icon: <ArrowBackIcon /> },
              { label: { key: 'backList' }, onClick: onClickBackToList, icon: <LowPriorityIcon /> },
            ],
          })
          setClear(false)
        },
        undefined,
        store
      )
    }
  }

  useEffect(() => {
    if (clear === true) {
      setError(defaultError)
      getOne(
        cons.PATH.SHOP.QUEUE.QUEUE_CONFIG + '/' + params.id,
        undefined,
        (payload) => {
          let newPayload = _.cloneDeep(payload)
          let newCustomData = JSON.parse(newPayload.customData)
          newPayload.queueSteps = JSON.parse(newPayload.queueSteps)
          newPayload.resourcesSteps = JSON.parse(newPayload.resourcesSteps)

          if (newCustomData) {
            newCustomData.forEach((item) => {
              if (item.type === 'EMAIL') {
                newPayload.email = item.required
              } else if (item.type === 'MOBILE') {
                newPayload.mobile = item.required
              }
            })
          }

          if (!newPayload.campaignType) {
            newPayload.campaignType = 'NONE'
          }

          if (!newPayload.vipType) {
            newPayload.vipType = 'NONE'
          }

          if (newPayload.prioritize === undefined) {
            newPayload.prioritize = false
          }

          dispatch(setQueueConfig(newPayload))
          setReady(true)
          setClear(false)
        },
        undefined,
        store
      )
    }
  }, [clear]) // eslint-disable-line react-hooks/exhaustive-deps

  // useEffect(() => {
  //   console.log('savedQueueConfig', savedQueueConfig)
  // }, [savedQueueConfig])

  // useEffect(() => {
  //   console.log('error', error)
  // }, [error])

  useEffect(() => {
    validate(savedQueueConfig)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedQueueConfig])

  return (
    ready && (
      <>
        <EditCreateDisplay
          code={params.id ? params.id : ''}
          resource={resource}
          tabs={false}
          content={content}
          onChangeInput={onChangeInput}
          bottomBtns={bottomBtns}
          display="none"
        />
        {dialog && dialog.open && <GlobalDialog dialogInfo={dialog} />}
        {resetDialogOpen && (
          <ResetDialog
            open={resetDialogOpen}
            setOpen={setResetDialogOpen}
            onClickReset={onClickReset}
            resetTimeStamp={savedQueueConfig.resetUpdateTimestamp}
            shopName={getRestaurantIdAndName(params.id)}
          />
        )}
      </>
    )
  )
}
